import { takeLatest, put, call } from 'redux-saga/effects';
import {
  getBackofficeCompanyQuotaDetailsAPI,
  getCompanyDetails,
  getLazyLoginTokenApi,
  getBackofficeCompanyMonthlyStatsAPI,
  getBackofficeCompanyTeamMembersStatsAPI,
} from '../../api/RecruiterDashboard/backoffice.api';
import {
  getCompanyDetailsSuccess,
  getCompanyDetailsFailure,
  getUserDetailsFailure,
  getUserDetailsSuccess,
  getLoazyLoginTokenSuccess,
  getLoazyLoginTokenFailure,
  getBoLedgerDetailsSuccess,
  getBoLedgerDetailsFailure,
  getBackofficeCompanyQuotaDetailsSuccess,
  getBackofficeCompanyQuotaDetailsFailure,
  getBackofficeMonthlyStatsDetailsSuccess,
  getBackofficeMonthlyStatsDetailsFailure,
  getBackofficeCompanyTeamMembersStatsSuccess,
  getBackofficeCompanyTeamMembersStatsFailure,
} from '../../actions/RecruiterDashboard/backoffice.actions';
import { AnyAction } from 'redux';
import {
  BO_GET_COMPANY_DETAILS_REQUEST,
  BO_GET_USER_DETAILS,
  GET_BO_COMPANY_QUOTA_DETAILS_REQUEST,
  GET_LAZY_LOGIN_TOKEN,
  GET_BO_COMPANY_MONTHLY_STATS_REQUEST,
  GET_BO_COMPANY_TEAM_MEMBERS_STATS_REQUEST,
  GET_BO_LEDGER_DETAILS_REQUEST,
} from '../../constants/ActionTypes';
import {
  getUserDetails,
  getLedgerDetailsApi,
} from '../../api/RecruiterDashboard/backoffice.api';
import { AxiosResponse } from 'axios';
import { showToast } from '../../actions/toast.action';
import { EToastVariant } from 'do-front-end-utils';

function* fetchCompanyDetails(action: AnyAction): Generator<any, void, any> {
  try {
    const { companySlug } = action.payload;
    const companyDetails = yield call(getCompanyDetails, companySlug);
    yield put(getCompanyDetailsSuccess(companyDetails));
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    yield put(getCompanyDetailsFailure(errorMessage));
  }
}

function* fetchUserDetails(action: AnyAction): Generator<any, void, any> {
  try {
    const response = yield call(getUserDetails, action.payload);
    yield put(getUserDetailsSuccess(response));
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    yield put(getUserDetailsFailure(errorMessage));
  }
}

function* getLazyLoginToken(action: AnyAction): Generator<any, void, any> {
  try {
    const { companySlug, username } = action.payload;
    const token = yield call(getLazyLoginTokenApi, { username, companySlug });
    yield put(getLoazyLoginTokenSuccess(token?.url));
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    yield put(getLoazyLoginTokenFailure(errorMessage));
  }
}

function* getBackofficeCompanyQuotaDetails(
  action: AnyAction
): Generator<any, void, any> {
  try {
    const { companySlug, username } = action.payload;
    const companyDetails: AxiosResponse = yield call(
      getBackofficeCompanyQuotaDetailsAPI,
      companySlug,
      username
    );
    yield put(getBackofficeCompanyQuotaDetailsSuccess(companyDetails.data));
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    yield put(getBackofficeCompanyQuotaDetailsFailure(errorMessage));
  }
}

function* getLedgerDetails(action: AnyAction): Generator<any, void, any> {
  try {
    const { companySlug, offset, productType, limit, from, to } =
      action.payload;
    const ledgerData = yield call(getLedgerDetailsApi, {
      offset,
      productType,
      limit,
      from,
      to,
      companySlug,
    });
    if (ledgerData?.meta) {
      yield put(
        getBoLedgerDetailsSuccess({
          result: ledgerData.results,
          count: ledgerData?.meta?.count,
          next: ledgerData?.meta?.next,
          previous: ledgerData?.meta?.previous,
        })
      );
    } else {
      yield put(getBoLedgerDetailsFailure('Meta data not found'));
      yield put(
        showToast({
          id: 'drd-ledger-details-error-toast',
          message: 'Meta data not found',
          variant: EToastVariant.SUCCESS,
        })
      );
    }
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    yield put(
      showToast({
        id: 'drd-ledger-details-error-toast',
        message: errorMessage,
        variant: EToastVariant.SUCCESS,
      })
    );
    yield put(getBoLedgerDetailsFailure(errorMessage));
  }
}
function* getBackofficeCompanyMonthlyStats(
  action: AnyAction
): Generator<any, void, any> {
  try {
    const { companySlug, username } = action.payload;
    const companyDetails: AxiosResponse = yield call(
      getBackofficeCompanyMonthlyStatsAPI,
      companySlug,
      username
    );
    yield put(getBackofficeMonthlyStatsDetailsSuccess(companyDetails.data));
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    yield put(getBackofficeMonthlyStatsDetailsFailure(errorMessage));
  }
}

function* getBackofficeCompanyTeamMembersStats(
  action: AnyAction
): Generator<any, void, any> {
  try {
    const { companySlug, username } = action.payload;
    const companyDetails: AxiosResponse = yield call(
      getBackofficeCompanyTeamMembersStatsAPI,
      companySlug,
      username
    );
    yield put(getBackofficeCompanyTeamMembersStatsSuccess(companyDetails.data));
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    yield put(getBackofficeCompanyTeamMembersStatsFailure(errorMessage));
  }
}

export default function* loadBackofficeSaga() {
  yield takeLatest(BO_GET_COMPANY_DETAILS_REQUEST, fetchCompanyDetails);
  yield takeLatest(BO_GET_USER_DETAILS, fetchUserDetails);
  yield takeLatest(GET_LAZY_LOGIN_TOKEN, getLazyLoginToken);
  yield takeLatest(
    GET_BO_COMPANY_QUOTA_DETAILS_REQUEST,
    getBackofficeCompanyQuotaDetails
  );
  yield takeLatest(
    GET_BO_COMPANY_MONTHLY_STATS_REQUEST,
    getBackofficeCompanyMonthlyStats
  );
  yield takeLatest(
    GET_BO_COMPANY_TEAM_MEMBERS_STATS_REQUEST,
    getBackofficeCompanyTeamMembersStats
  );

  yield takeLatest(GET_BO_LEDGER_DETAILS_REQUEST, getLedgerDetails);
}
